import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function AppsFAQ({ className }) {
    const [showQues, setQues] = useState(1);
    const openQuestion = (value) => {
        setQues(value);
    };
    return (
        <>
            <section
                id="app-faq-section"
                className={`appie-faq-area pb-100 pt-100 ${className || ''}`}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="appie-section-title text-center">
                                <h2 className="as-h3 appie-title">Frequently asked questions</h2>
                                <p>
                                    Find answers to commonly asked questions about our software
                                    suite
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div
                                className="faq-accordion wow fadeInRight mt-30"
                                data-wow-duration="1500ms"
                            >
                                <div
                                    className="accrodion-grp animated fadeIn faq-accrodion wow"
                                    data-wow-duration="1500ms"
                                    data-grp-name="faq-accrodion"
                                >
                                    <div
                                        onClick={() => openQuestion(1)}
                                        className={`accrodion ${showQues === 1 ? 'active' : ''}`}
                                    >
                                        <div className="accrodion-inner">
                                            <div className="accrodion-title">
                                                <h3 className="as-h4">
                                                    How does OTO's software suite work?
                                                </h3>
                                            </div>
                                            <div
                                                className="accrodion-content"
                                                style={{
                                                    display: showQues === 1 ? 'block' : 'none',
                                                }}
                                            >
                                                <div className="inner">
                                                    <p>
                                                        Our software suite is cloud-based and
                                                        accessible from any device with an internet
                                                        connection. Simply create an account and log
                                                        in to access your chosen app. Additionally,
                                                        we offer an on-premise installation for
                                                        customers that may need it.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        onClick={() => openQuestion(2)}
                                        className={`accrodion ${showQues === 2 ? 'active' : ''}`}
                                    >
                                        <div className="accrodion-inner">
                                            <div className="accrodion-title">
                                                <h3 className="as-h4">
                                                    How much does OTO's software suite cost?
                                                </h3>
                                            </div>
                                            <div
                                                className="accrodion-content"
                                                style={{
                                                    display: showQues === 2 ? 'block' : 'none',
                                                }}
                                            >
                                                <div className="inner">
                                                    <p>
                                                        Our software suite is competitively priced,
                                                        with options for businesses of all sizes and
                                                        budgets. Pricing varies depending on the app
                                                        and the plan you choose. Visit our pricing
                                                        page for more information.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        onClick={() => openQuestion(4)}
                                        className={`accrodion ${showQues === 4 ? 'active' : ''}`}
                                    >
                                        <div className="accrodion-inner">
                                            <div className="accrodion-title">
                                                <h3 className="as-h4">
                                                    What kind of businesses can benefit from OTO's
                                                    software suite?
                                                </h3>
                                            </div>
                                            <div
                                                className="accrodion-content"
                                                style={{
                                                    display: showQues === 4 ? 'block' : 'none',
                                                }}
                                            >
                                                <div className="inner">
                                                    <p>
                                                        Our software suite is designed for
                                                        businesses of all sizes and industries. Our
                                                        inventory management app is perfect for
                                                        retailers and wholesalers, while our
                                                        financing app is ideal for service-based
                                                        businesses. Our POS app is perfect for
                                                        brick-and-mortar stores, and our hotel
                                                        management app is tailored specifically for
                                                        the hospitality industry.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div
                                className="faq-accordion wow fadeInRight mt-30"
                                data-wow-duration="1500ms"
                            >
                                <div
                                    className="accrodion-grp animated fadeIn faq-accrodion wow"
                                    data-wow-duration="1500ms"
                                    data-grp-name="faq-accrodion"
                                >
                                    <div
                                        onClick={() => openQuestion(3)}
                                        className={`accrodion ${showQues === 3 ? 'active' : ''}`}
                                    >
                                        <div className="accrodion-inner">
                                            <div className="accrodion-title">
                                                <h3 className="as-h4">
                                                    What are the benefits of using OTO's software
                                                    suite?
                                                </h3>
                                            </div>
                                            <div
                                                className="accrodion-content"
                                                style={{
                                                    display: showQues === 3 ? 'block' : 'none',
                                                }}
                                            >
                                                <div className="inner">
                                                    <p>
                                                        Our software suite is designed to save you
                                                        time and increase efficiency by automating
                                                        tasks and streamlining operations. Our apps
                                                        are user-friendly, customizable, and
                                                        accessible from anywhere, so you can work
                                                        on-the-go. Plus, our customer support team
                                                        is always available to help.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        onClick={() => openQuestion(5)}
                                        className={`accrodion ${showQues === 5 ? 'active' : ''}`}
                                    >
                                        <div className="accrodion-inner">
                                            <div className="accrodion-title">
                                                <h3 className="as-h4">
                                                    Can I try OTO's software suite before committing
                                                    to a plan?
                                                </h3>
                                            </div>
                                            <div
                                                className="accrodion-content"
                                                style={{
                                                    display: showQues === 5 ? 'block' : 'none',
                                                }}
                                            >
                                                <div className="inner">
                                                    <p>
                                                        Yes! We offer a free trial period for each
                                                        of our apps. Simply create an account and
                                                        log in to access your chosen app and start
                                                        exploring its features.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        onClick={() => openQuestion(6)}
                                        className={`accrodion ${showQues === 6 ? 'active' : ''}`}
                                    >
                                        <div className="accrodion-inner">
                                            <div className="accrodion-title">
                                                <h3 className="as-h4">
                                                    Is OTO's software suite secure?
                                                </h3>
                                            </div>
                                            <div
                                                className="accrodion-content"
                                                style={{
                                                    display: showQues === 6 ? 'block' : 'none',
                                                }}
                                            >
                                                <div className="inner">
                                                    <p>
                                                        Yes! We take security seriously and use the
                                                        latest encryption technology to ensure your
                                                        data is safe and secure. Our software suite
                                                        is also compliant with industry standards
                                                        and regulations.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="faq-text text-center pt-40">
                                <p>
                                    Still can't find answers to your questions ?
                                    <Link className="ml-2" to="/contact">
                                        Contact us
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default AppsFAQ;
